import * as React from 'react';
import { GroupServiceGetResponse, RateReliefCalculatorServiceResponse } from '../../services/api';
import { createPortal } from 'react-dom';
import { Message } from 'primereact/message';
import { GroupStatus } from '../../utils/types';
import { asPercentageValue } from '../../utils/parse';

export default function GroupBanner({ group, rates, onViewNotes }: { group: GroupServiceGetResponse, rates: RateReliefCalculatorServiceResponse, onViewNotes: (e: React.MouseEvent<HTMLAnchorElement>) => void }) {
  const targetElement: HTMLElement | null = document.getElementById('data-top-notification');

  const compQuoteNeeded = !!rates.compQuoteNeededForAdditionalRelief;
  const hasDentalPlan = !!group.policyDetailModel?.dentalVisionGroup;

  console.log({ compQuoteNeeded})
  
  const messageContents = React.useMemo(() => {
    switch (true) {
      case group.requestStatus === GroupStatus.TIER2_REQUESTED:
        return {
          title: 'Tier 2 requested',
          message: (<p>Group has requested a Tier 2:  <a href="#" onClick={onViewNotes}>View supporting note</a></p>),
          severity: 'warn',
          icon: 'pi pi-check-circle',
        };
      case group.requestStatus === GroupStatus.RERATE_REQUESTED:
        return {
          title: 'Rerate requested',
          message: (<p>Group has requested a rerate: <a href="#" onClick={onViewNotes}>View supporting note</a></p>),
          severity: 'warn',
          icon: 'pi pi-check-circle',
        };
      case group.requestStatus === GroupStatus.TIER2_COMPLETED:
        return {
          title: 'Tier 2 updated by Actuarial',
          message: (<p>Additional relief has been approved: <a href="#" onClick={onViewNotes}>View supporting note</a></p>),
          severity: 'success',
          icon: 'pi pi-check-circle',
        };
      case group.requestStatus === GroupStatus.RERATE_COMPLETED:
        return {
          title: 'Rerate updated by Actuarial',
          message: (<p>A rerate has been processed for this group by Actuarial: <a href="#" onClick={onViewNotes}>View supporting note</a></p>),
          severity: 'success',
          icon: 'pi pi-check-circle',
        };
      case group.requestStatus === GroupStatus.HIGH_RISK_REQUESTED:
        return {
          title: 'Request to remove High Risk status',
          message: (<p>Following rerate analysis, this group is now eligible for rate relief: <a href="#" onClick={onViewNotes}>View supporting note</a></p>),
          severity: 'warn',
          icon: 'pi pi-exclamation-triangle',
      };
      case group.requestStatus === GroupStatus.HIGH_RISK:
        return {
          title: 'This group has been locked',
          message: (<p>Due to it's high risk claims post pricing this group has been locked: <a href="#" onClick={onViewNotes}>View supporting note</a></p>),
          severity: 'error',
          icon: 'pi pi-lock',
        };
      case compQuoteNeeded:
        return {
          title: 'Comp quote needed for additional relief',
          message: (
            <p>Increase prior to aggressive rating - {asPercentageValue((rates.increasePriorToAggressiveRating || 0) * 100, 0)}</p>
          ),
          severity: 'warn',
          icon: null,
        };
      case hasDentalPlan:
        return {
          title: 'This group has a dental plan',
          message: (<p>Remove dental/vision plan within web quoting plan tab, then apply rate relief, then re-apply dental/vision plan in Web Quoting.</p>),
          severity: 'error',
          icon: null,
        };
      default:
        return null;
    }
  }, [group, rates]);

  if (!messageContents) return null;

  return createPortal(
    <Message
      className="w-full rounded-none"
      severity={messageContents.severity}
      text={
        <div>
          <div className="font-bold">{messageContents?.title}</div>
          {messageContents.message}
        </div>
      }
      icon={messageContents.icon || null}
    />,
    targetElement!
  );
}